// Vietnamese language file
export const VI = {
  preparing_zip: "Đang chuẩn bị tệp zip…",
  compressing: "Đang nén…",
  info_icon: "Khi được đánh dấu là hoàn thành, không có thành viên bổ sung nào có thể tham gia hoặc được thêm vào, và tất cả các nhóm trò chuyện sẽ bị vô hiệu hóa. Xin lưu ý rằng dự án, cùng với tất cả các nhóm trò chuyện và dữ liệu, sẽ vẫn có thể truy cập ở trạng thái bị vô hiệu hóa.",
  mark_is_done: "Bạn có chắc chắn muốn đánh dấu dự án là hoàn thành không? Khi được đánh dấu, không có thành viên bổ sung nào có thể tham gia hoặc được thêm vào, và tất cả các nhóm trò chuyện sẽ bị vô hiệu hóa. Xin lưu ý rằng dự án, cùng với tất cả các nhóm trò chuyện và dữ liệu, sẽ vẫn có thể truy cập ở trạng thái bị vô hiệu hóa.",
  mark_not_done: "Bạn có chắc chắn muốn mở lại dự án không? Khi được đánh dấu là mở, các thành viên bổ sung có thể tham gia hoặc được thêm vào, và tất cả các nhóm trò chuyện sẽ được kích hoạt lại.",
  mark_as_completed: "Đánh dấu dự án là hoàn thành",
  room_completed: "Dự án đã hoàn thành",
  room_members: "Thành viên dự án",
  deactivated_rooms: "Dự án bị vô hiệu hóa",
  deactivated_chats: "Trò chuyện bị vô hiệu hóa",
  completed_rooms: "Dự án đã hoàn thành",
  request_to_join_a_room: 'Yêu cầu tham gia dự án',
  wants_to_rejoin_room: 'Username muốn tham gia lại dự án Roomname.',
  invited_you_to_join_room: 'Username đã mời bạn tham gia dự án Roomname.',
  restart: "Khởi động lại",
  update_text: "Có bản cập nhật mới. Nhấp vào khởi động lại để cài đặt bản cập nhật.",
  update_availble: "Có bản cập nhật",
  Loading: "Đang tải...",
  logout: "Đăng xuất",
  back: 'Quay lại',
  company_list: "Danh sách công ty",
  followers: "Người theo dõi",
  followings: "Đang theo dõi",
  article: "Bài viết",
  companies: "Công ty",
  one_to_one_chat: " Trò chuyện một đối một",
  profile: "Hồ sơ",
  company: "Công ty",
  company_selection: "Lựa chọn công ty",
  home: "Trang chủ",
  contact: "Liên hệ ",
  add_company: "Thêm công ty ",
  add_project: "Thêm dự án ",
  capacities: "Năng lực ",
  work_area: "Khu vực làm việc",
  company_services: "Dịch vụ công ty",
  website: "Trang web",
  search_contacts: "Tìm kiếm liên hệ",
  add_or_join_a_company: "Thêm hoặc tham gia công ty",
  follow: "Theo dõi",
  following: "Đang theo dõi",
  like: "Thích",
  company_contacts: "Liên hệ công ty",
  leave_the_company: "Rời khỏi công ty",
  news: "Tin tức",
  earlier: "Trước đó",
  action: "Hành động",
  another_action: "Hành động khác",
  something_else: "Khác",
  search: "Tìm kiếm",
  search_rooms: "Tìm kiếm dự án",
  search_articles: "Tìm kiếm bài viết",
  contacts: "Liên hệ",
  suggestions: "Đề xuất",
  project_list: "Danh sách dự án",
  search_results: "Kết quả tìm kiếm",
  add_or_join_project: "Thêm hoặc tham gia dự án",
  details: "Chi tiết",
  your_position_within_company: "Vui lòng chọn vị trí của bạn trong công ty.",
  close_modal: "Đóng",
  map: "Bản đồ",
  or: "Hoặc",
  name: "Tên*",
  street: "Đường*",
  house_number: "Số nhà",
  postal_code: "Mã bưu điện",
  city: "Thành phố*",
  opened_by: "Được mở bởi:",
  project_No: "Số dự án: ",
  building_type: "Loại tòa nhà*",
  building_types: "Loại tòa nhà",
  add_join: "Thêm/Tham gia",
  mandatory_fiels: "*các trường bắt buộc",
  invalid_fiels: "Trường này là bắt buộc",
  add_or_join_company: "Thêm hoặc tham gia công ty",
  name_of_the_company: "Tên công ty",
  edit_company_details: "Chỉnh sửa chi tiết công ty",
  branch_of_the_building_industry: "Ngành xây dựng",
  corporate_form: "Hình thức công ty",
  position_within_company: "Vị trí trong công ty",
  request_confirmation: "Yêu cầu dự án đang chờ",
  company_e_mail: "Email công ty",
  type_of_filter: "Nhập để lọc...",
  setting: "Cài đặt",
  dashboard: "Bảng điều khiển",
  settings: "Cài đặt",
  views: "Lượt xem",
  times_seen: "lần xem",
  see_more: "...thêm",
  see_less: "...ít hơn",
  in_search: "trong tìm kiếm",
  reset_password: "Đặt lại mật khẩu",
  submit: "Gửi",
  password: "Mật khẩu",
  email: "Email",
  confirm_password: "Xác nhận mật khẩu",
  reset_email: "Đặt lại Email",
  update: "Cập nhật",
  new_email: "Email mới",
  kjuup_message: "Tin nhắn Kjuup",
  delete_profile: "Xóa hồ sơ?",
  my_position: "Vị trí của tôi:",
  add: "thêm",
  owner_company_admin: "Quản trị viên công ty:",
  owner_company_admin_new: "Quản trị viên công ty",
  mutual_contact: "liên hệ chung",
  mutual_contacts: "liên hệ chung",
  co_owner: "Đồng sở hữu",
  managing_director: "Giám đốc điều hành",
  associate: "Cộng tác viên",
  secretary: "Thư ký",
  employee: "Nhân viên",
  project_manage: "Quản lý dự án",
  auto_chat_translation: "Dịch trò chuyện tự động",
  translate_room_group_names: "Dịch tên dự án và nhóm",
  translate_room_group_names_info: "Khi bật, tên dự án và nhóm trò chuyện được tự động dịch sang ngôn ngữ giao diện.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Khi được bật, tab E-Mail sẽ mở mặc định thay vì Tin nhắn khi bạn mở ứng dụng.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Ngôn ngữ",
  english: "Tiếng Anh",
  german: "Tiếng Đức",
  french: "Tiếng Pháp",
  italian: "Tiếng Ý",
  change_language: "Thay đổi ngôn ngữ",
  my_companies: "Công ty của tôi",
  employees: "Nhân viên",
  invite_with_a: "Mời đến Kjuup",
  add_member: "Thêm thành viên",
  add_user: "Thêm người dùng",
  send_location: "Gửi vị trí",
  assign_admin_rights: "Điều chỉnh quyền quản trị",
  deactivate_company: "Vô hiệu hóa công ty",
  remove_employees: "Xóa nhân viên",
  remove_members: "Xóa thành viên",
  no_user_found: "Không tìm thấy người dùng!",
  approve: "Phê duyệt!",
  deselect_all: "Bỏ chọn tất cả",
  select_all: "Chọn tất cả",
  translation_on_building_projects: "Dịch trong dự án",
  reported_capacities: "Dịch vụ đã báo cáo",
  up_to_50m_exact: "Chính xác đến 50m",
  company_details_service: "Dịch vụ công ty",
  company_contact: "Liên hệ công ty",
  invite_with_link: "Mời đến Kjuup",
  share_link: "Chia sẻ liên kết",
  share_company_link: "Chia sẻ liên kết",
  qr_code: "Mã QR",
  copy_link: "Sao chép liên kết",
  cancel_link: "Hủy liên kết",
  who_has_confirmed_services: "Ai đã xác nhận dịch vụ của bạn?",
  projectss: "Dự án",
  add_services: "Thêm dịch vụ",
  services: "Dịch vụ",
  save_text: "Lưu",
  share_on: "Chia sẻ trên:",
  articlen: "Bài viết",
  invite_user_to_confirm_service: "Mời người dùng xác nhận dịch vụ cho công ty.",
  link_copied: "Đã sao chép liên kết!",
  email_copied: "Đã sao chép email!",
  personal_article: "Bài viết cá nhân",
  company_article: "Bài viết công ty",
  characters_remaining: "Ký tự còn lại",
  optional_information: "Thông tin tùy chọn",
  project: "Dự án",
  projects: "Dự án...",
  abort: "Hủy bỏ",
  preview: "Xem trước",
  post: "Đăng",
  of: "của",
  remove: "Xóa",
  free_capacity: "Cổng việc làm",
  current_status_overview: "Tổng quan trạng thái hiện tại",
  report_capacities: "Báo cáo dịch vụ",
  report_text: "Báo cáo",
  search_capacities: "Tìm nhà thầu",
  add_project_user: "Thêm người dùng dự án",
  media: "Phương tiện",
  links: "Liên kết",
  docs: "Tài liệu",
  featured_products: "Sản phẩm nổi bật...",
  title: "Tiêu đề",
  text: "Văn bản",
  feed_details: "Chi tiết nguồn cấp",
  add_employee: "Thêm nhân viên",
  latest: "Mới nhất",
  my_projects: "Dự án của tôi",
  cancel: "Hủy",
  continue: "Tiếp tục",
  role_in_the_building_industry: "Vai trò trong ngành xây dựng",
  als: "như",
  join: "tham gia",
  find: "Tìm",
  request_to_join_a_company: "Yêu cầu tham gia công ty",
  wants_to_join_the_company: "muốn tham gia công ty",
  filter_by: "Lọc theo",
  ok: "Ok",
  close: "Đóng",
  weekly_statistics: "Thống kê hàng tuần",
  is_following_you: "đang theo dõi bạn.",
  as: "như",
  has_joined_the: "đã tham gia công ty",
  has_looked_at_your_profile: "đã xem hồ sơ của bạn.",
  time: "Thời gian",
  in_searches_in_past_week: "trong tìm kiếm tuần trước.",
  has_liked_your_article: "đã thích bài viết của bạn.",
  has_published_a_new_article: "đã xuất bản một bài viết mới.",
  you: "Bạn",
  all_views: "Tất cả lượt xem",
  all_profile_views: "Tất cả lượt xem hồ sơ",
  mutual_company: "công ty chung",
  artical_text: "Viết bài viết...",
  you_have_appeared: "Bạn đã xuất hiện",
  your_request_at_the_company: "Yêu cầu của bạn tại công ty",
  times_you_have_appeared_in_searches: "lần bạn đã xuất hiện trong tìm kiếm",
  appear_more_often_in_searches: "Xuất hiện thường xuyên hơn trong tìm kiếm",
  you_have_been_found: "Bạn đã được tìm thấy",
  improve_profile: "Cải thiện hồ sơ",
  choose_existing_contact_for_single_chat: "Chọn liên hệ hiện có cho trò chuyện đơn:",
  in_order_to_add_new_contacts: "Để thêm liên hệ mới, vui lòng tìm kiếm liên hệ mới trên trang hồ sơ.",
  times_in_searches_in_the_last_week: "lần trong tìm kiếm tuần trước. Cập nhật hồ sơ của bạn và thêm chi tiết để dễ dàng được tìm thấy hơn.",
  has_been_confirmed: "đã được xác nhận.",
  have_joined_the: "đã tham gia ",
  building_project: " dự án xây dựng.",
  select_with_which_company_you_want_to_connect_to_the_project: "Bạn sẽ đại diện cho công ty nào. Điều này sẽ được hiển thị cho những người tham gia khác.",
  select_with_which_company_you_want_to_connect_to_the_chat: "Bạn sẽ đại diện cho công ty nào. Điều này sẽ được hiển thị cho những người tham gia khác.",
  select_internal_section: "Vui lòng chọn phần nội bộ",
  select_profile_image: "Chọn hình ảnh hồ sơ",
  share_user: "Chia sẻ người dùng",
  contact_sender_message: "Chia sẻ liên kết này để mời người không phải thành viên của Kjuup đến Kjuup. Liên kết này có thể được nhiều người sử dụng để đăng ký.",
  project_sender_message: "Chia sẻ liên kết này để mời người không phải thành viên của Kjuup đến dự án “tên dự án”. Liên kết này có thể được nhiều người sử dụng để đăng ký và tham gia dự án “tên dự án” trong Kjuup.",
  company_sender_message: "Chia sẻ liên kết này để mời người không phải thành viên của Kjuup đến công ty tên công ty. Liên kết này có thể được nhiều người sử dụng để đăng ký và tham gia công ty trong Kjuup.",
  contact_receivers_message: "Liên kết mời tham gia Kjuup. Vui lòng nhấp vào liên kết để đăng ký kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message: "Trong trường hợp bạn đang cài đặt Kjuup qua Apple App Store, bạn phải nhấp vào liên kết này sau khi tải xuống thành công, để có thể đăng ký.",
  project_receivers_message: "Liên kết mời tham gia dự án “tên dự án” trong Kjuup. Vui lòng nhấp vào liên kết để đăng ký Kjuup và tham gia dự án “tên dự án”.",
  company_receivers_message: "Liên kết mời đến công ty tên công ty trong Kjuup. Vui lòng nhấp vào liên kết để đăng ký Kjuup và tham gia công ty tên công ty.",
  sign_in: "Đăng nhập",
  enter_your_email_add: "Nhập địa chỉ email của bạn",
  forgot_password: "Quên mật khẩu",
  dont_have_account: "Chưa có tài khoản?",
  register: "Đăng ký",
  get_app: "Tải ứng dụng",
  registration: "Đăng ký",
  dep_ing: "Dipl.-Ing.",
  dr: "Tiến sĩ",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "Giáo sư",
  first_name: "Tên",
  last_name: "Họ",
  have_an_account: "Đã có tài khoản?",
  when_register_you_agree: "Khi đăng ký, bạn đồng ý với",
  term_of_use: "điều khoản sử dụng",
  to: "của chúng tôi.",
  in_our: "Trong",
  data_policy: "chính sách dữ liệu",
  they_find_out: "họ tìm hiểu,",
  we_provide_store_data: "cách chúng tôi thu thập, xử lý và lưu trữ thông tin.",
  leaving_company_text: "Bạn có thực sự muốn rời khỏi công ty không? Khi rời khỏi công ty, bạn cũng rời khỏi tất cả các dự án và nhóm trò chuyện liên quan. Bạn có thể tham gia lại các dự án này với một công ty khác bất cứ lúc nào.",
  delete_profile_text: "Bạn có thực sự muốn xóa hồ sơ của mình không? Khi xóa hồ sơ, tất cả các kết nối với công ty, dự án và trò chuyện sẽ bị xóa. Bạn có thể tạo hồ sơ mới bất cứ lúc nào.",
  confirm: "Xác nhận",
  reject: "Từ chối",
  requet_to_leave: "Yêu cầu rời đi",
  choose: "Chọn",
  your_add_member: "Thêm thành viên",
  if_you: "trong trường hợp bạn",
  can_not_find: "không thể tìm thấy liên hệ của bạn ở đây.",
  please_wait: "Vui lòng đợi..",
  imprint_gtc: "Dấu ấn/Điều khoản và Điều kiện",
  register_confirm_popup: "Vui lòng xác minh email Kjuup trước khi đăng nhập. Chúng tôi đã gửi liên kết xác nhận. Nếu không thấy, hãy kiểm tra cả thư mục spam.",
  PENDING_GROUP_USER: "sẽ chỉ nhận được tin nhắn sau khi lời mời vào dự án được xác nhận. Một tin nhắn bổ sung sẽ xuất hiện khi lời mời vào dự án được xác nhận.",
  PENDING: "Xác nhận lời mời vào dự án đang chờ",
  denied_group_chat: " đã từ chối lời mời vào dự án và đã rời khỏi nhóm này.",
  joined_group_chat: " đã tham gia nhóm này",
  you_joined_group_chat: "Bạn đã tham gia nhóm này.",
  Others: "Khác",
  LEFT_GROUP: "đã rời khỏi nhóm trò chuyện này.",
  YOU_LEFT_GROUP: "đã rời khỏi nhóm trò chuyện này.",
  days: "ngày",
  day: "ngày",
  hour: "giờ",
  hide_project: "Ẩn dự án",
  hide_project_popup_text: "Nếu bạn ẩn dự án, chúng không thể được tìm thấy trong Kjuup. Chỉ các thành viên của dự án mới có thể mời người dùng mới vào dự án.",
  branch: "Ngành",
  photo_video_media_lib: "Thư viện phương tiện - Ảnh và Video",
  document: "Tài liệu",
  location_meeting: "Vị trí / Cuộc họp",
  all_member_of_project: "Tất cả thành viên của dự án",
  pending_request: "Yêu cầu dự án đang chờ",
  no_pending_request: "Không tìm thấy yêu cầu đang chờ!",
  news_feed: "Nguồn cấp tin tức",
  user_info: "Thông tin nhóm",
  leave_project: "Rời khỏi dự án",
  media_link_docs: "Tệp",
  search_chat: "Tìm kiếm trò chuyện",
  export_chat_group: "Xuất dữ liệu nhóm trò chuyện từ tháng trước",
  request_complete_chat_history: "Yêu cầu lịch sử trò chuyện đầy đủ",
  leave_chat_group: "Rời khỏi nhóm trò chuyện",
  add_user_project: "Thêm người dùng",
  me: "Tôi",
  max_open_one_to_one: "Hiện tại tối đa 2 trò chuyện một đối một có thể được mở song song ở phần dưới và trên. Tổng cộng tối đa 4 trò chuyện một đối một là có thể.",
  are_you_sure_you_want_leave_chat: "Bạn có chắc chắn muốn rời khỏi nhóm trò chuyện này không?",
  create_group: "Tạo nhóm",
  adding_members: "Đang thêm thành viên...",
  creating_the_chat: "Đang tạo cuộc trò chuyện...",
  finishing_setup: "Đang hoàn tất...",
  group_name: "Tên nhóm",
  by: "Bởi:",
  mandetory: "*bắt buộc",
  delteed: "đã xóa hồ sơ của mình và đã rời khỏi trò chuyện nhóm.",
  deleted_direct: "đã xóa hồ sơ của mình và đã rời khỏi cuộc trò chuyện.",
  unhidden_message: "Nếu bạn bỏ ẩn dự án, chúng có thể được tìm thấy bởi tất cả thành viên của Kjuup.",
  account_deleted: "Tài khoản đã bị xóa.",
  refuse_company: "Bạn có chắc chắn muốn từ chối lời mời công ty không?",
  follow_additional: "Theo dõi người dùng bổ sung",
  f_add: "Theo dõi người dùng bổ sung của Kjuup để làm cho họ có sẵn cho tin nhắn trực tiếp.",
  c_inv: "Lời mời công ty",
  invited_o_Company: "Bạn đã được mời tham gia công ty",
  refuse_companyX: "Bạn có chắc chắn muốn từ chối yêu cầu công ty không?",
  a_Da: "Tài khoản đã bị vô hiệu hóa.",
  has_deactivated: "đã vô hiệu hóa hồ sơ của mình.",
  reactive: "đã kích hoạt lại hồ sơ của mình.",
  juup_note: "*Đăng ký với tên người dùng chỉ có sẵn cho thành viên Kjuup+",
  username: "Tên người dùng*",
  email_username: "Email/Tên người dùng*",
  sPinText: "Vui lòng cung cấp mã PIN bảo mật 6 chữ số. Mã PIN này sẽ cần thiết trong trường hợp bạn quên mật khẩu và là bắt buộc để xác nhận tài khoản của bạn.",
  DeleteKjuupPlusText: "Bạn có thực sự muốn xóa hồ sơ của mình không? Khi xóa hồ sơ, tất cả các kết nối với công ty, dự án và trò chuyện sẽ bị xóa.\n\nTrong vòng 48 giờ sau khi xóa tài khoản, bạn có thể kích hoạt lại tài khoản bằng cách đăng nhập bằng tên người dùng, mật khẩu và mã PIN.",
  reactive_text: "Tài khoản của bạn đã bị xóa. Vui lòng nhấp vào Kích hoạt lại để kích hoạt lại tài khoản của bạn.",
  rac: "Kích hoạt lại",
  ac_ss: "Tài khoản đã được kích hoạt lại thành công.",
  not_valid_pin: "Mã PIN không hợp lệ",
  only_for_kjuup: "*Đặt lại mật khẩu qua tên người dùng và mã PIN chỉ có sẵn cho thành viên Kjuup+.",
  resetPIN: "Đặt lại PIN",
  enter_current_pin: "Vui lòng nhập mã PIN hiện tại của bạn",
  enter_new: "Nhập mã PIN mới",
  pin_to_confirm: "Vui lòng cung cấp mã PIN để xác nhận.",
  change_username: "Đặt lại tên người dùng",
  pp_not_match: "Mật khẩu - và Xác nhận mật khẩu không khớp",
  reactive_itself: "Bạn đã kích hoạt lại hồ sơ của mình.",
  has_deactivated_itself: "Bạn đã vô hiệu hóa hồ sơ của mình.",
  more_than_two: "Hiện tại tin nhắn trực tiếp chỉ có thể được thực hiện với 2 người dùng song song.",
  Chats: "Tin nhắn trực tiếp",
  only_in_mobileL: "Video gốc hiện chỉ có thể được tải lên và đăng qua ứng dụng di động. Vui lòng sử dụng liên kết video của Youtube và Vimeo.",
  register_pin_text: "Vui lòng chọn mã PIN cá nhân 6 chữ số của bạn. Mã PIN này sẽ cần thiết để kích hoạt các chức năng đặt lại tài khoản.",
  internal_project: "Nội bộ",
  external_projects: "Bên ngoài",
  in_deacticted: "Phần nội bộ đã bị vô hiệu hóa.",
  create_article: "Tạo bài viết",
  new_article_selection: "Tạo bài viết cho nguồn cấp tin tức bên ngoài",
  new_article_selection_internal: "Tạo bài viết nội bộ",
  active_trans_title: "Bật dịch tự động?",
  active_trans: "Khi bật, tất cả tin nhắn trò chuyện đến sẽ được dịch sang ngôn ngữ ứng dụng bạn đã chọn.",
  disable_trans: "Bạn có thực sự muốn vô hiệu hóa dịch tự động không?",
  allow_access_chat: "Hiển thị lịch sử trò chuyện đầy đủ",
  toggle_chat_history_on: "Bạn có thực sự muốn người dùng xem lịch sử trò chuyện đầy đủ không?",
  toggle_chat_history_off: "Bạn có thực sự muốn người dùng chỉ xem lịch sử trò chuyện từ điểm tham gia trò chuyện không?",
  check_selected_settings: "Vui lòng kiểm tra cài đặt lịch sử trò chuyện cho tất cả người dùng đã chọn!",
  chat_from_start_have: "Bạn đã tham gia nhóm này. Lịch sử trò chuyện đã được chia sẻ.",
  chat_from_start_has: "đã tham gia nhóm này. Lịch sử trò chuyện đã được chia sẻ.",
  Address: "Địa chỉ",
  read_by: "Đọc bởi",
  deliver_to: "Gửi đến",
  remaining: "còn lại",
  message_info: "Thông tin tin nhắn",
  request_to_join_only: "Yêu cầu tham gia",
  unfollow: "Bỏ theo dõi",
  company_username: "Tên người dùng",
  month: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
  remove_my_admin_right: "Xóa quyền quản trị của tôi",
  makeEmp: "Bạn có thực sự muốn xóa quyền quản trị viên công ty khỏi người dùng không?",
  remove_my_self: "Bạn có thực sự muốn xóa quyền quản trị viên công ty khỏi tài khoản của bạn không?",
  makeAdmin: "Bạn có thực sự muốn cấp quyền quản trị viên công ty cho người dùng không?",
  remove_member: "Xóa thành viên",
  remove_following_confirm: "Bạn có thực sự muốn xóa {name} khỏi danh sách theo dõi không?",
  remove_follower_confirm: "Bạn có thực sự muốn xóa {name} khỏi người theo dõi bạn không? Nếu xóa, họ sẽ không được thông báo.",
  do_you_really_want_to_remove: "Bạn có thực sự muốn xóa tên người dùng khỏi công ty không?",
  invite_all: "Mời tất cả thành viên của công ty",
  invite_all_members: "Mời tất cả thành viên",
  mems: "Tất cả thành viên khác",
  dep_loc: "Phòng ban/Vị trí/Nhóm",
  depAdmin: "Quản trị viên phòng ban",
  add_remove_admin: "Thêm/Xóa vị trí quản trị viên công ty",
  add_remove_dep_admin: "Thêm/Xóa vị trí quản trị viên phòng ban",
  remove_employees_dept: "Xóa nhân viên khỏi",
  want_to_join_dep: "Tên người dùng muốn tham gia Phòng ban/Vị trí/Nhóm depname của công ty companyname.",
  you_invited: "Bạn đã được mời tham gia Phòng ban/Vị trí/Nhóm depname của công ty companyname.",
  dep_remove: "Bạn có thực sự muốn xóa quyền quản trị cho phòng ban hoặc vị trí khỏi người dùng không?",
  add_dep: "Bạn có thực sự muốn cấp quyền quản trị cho phòng ban hoặc vị trí cho người dùng không?",
  my_self_dep_remove: "Bạn có thực sự muốn xóa quyền quản trị viên phòng ban khỏi tài khoản của bạn không?",
  member: "Thành viên",
  admin: "Quản trị viên",
  remove_project_admin: "Bạn có thực sự muốn xóa thành viên khỏi dự án không?",
  remove_my_self_project: "Bạn có thực sự muốn xóa quyền quản trị không?",
  remove_member_admin_right: "Bạn có thực sự muốn xóa quyền quản trị khỏi người dùng không?",
  add_member_admin_right: "Bạn có thực sự muốn thêm quyền quản trị cho người dùng không?",
  add_remove_Poss: "Thêm/Xóa vị trí quản trị viên",
  forward: "Chuyển tiếp",
  edit: "Chỉnh sửa",
  only_kjuup_plus_can: "Chỉ các công ty Kjuup+ mới có thể đăng bài viết.",
  add_images: "Thêm hình ảnh",
  request_confirmation: 'Lời mời dự án đang chờ',
  Activity: "Hoạt động",
  latest_messages: "Tin nhắn mới nhất",
  hours: "giờ",
  minute: "phút",
  seconds: "giây",
  days: "ngày",
  yesterday: "hôm qua",
  last_week: "tuần trước",
  next_week: "tuần tới",
  Last_month: "tháng trước",
  All: "Tất cả",
  register_plus: "Đăng ký Plus",
  select_files: "Chọn tệp",
  monthsFullName: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
  company_deploc_receivers_message: "Liên kết mời đến phòng ban của công ty company name trong Kjuup. Vui lòng nhấp vào liên kết để đăng ký Kjuup và tham gia công ty company name.",
  no_news: "Không có tin tức",
  reminder: "Nhắc nhở",
  np_reminder: "Không có ToDo",
  move_to_reminder: "Chuyển đến ToDo",
  remove_reminder: "Bạn có thực sự muốn xóa tin nhắn này khỏi danh sách ToDo của bạn không?",
  remove_all_reminder: "Xóa tất cả ToDo",
  remove_all_confirm: "Bạn có thực sự muốn xóa tất cả tin nhắn khỏi danh sách ToDo của bạn không?",
  remove_from_reminder: "Xóa khỏi nhắc nhở",
  prevent_email: "Email không thể được sử dụng làm tên người dùng.",
  allow_noti: "Vui lòng cho phép thông báo.",
  join_cap: "Tham gia",
  pass_minimum: "**Mật khẩu yêu cầu 12 ký tự bao gồm chữ thường, chữ hoa, số và ký tự đặc biệt.",
  pass_error: "Vui lòng kiểm tra yêu cầu mật khẩu",
  people_that_like_article: "Những người thích bài viết.",
  people_who_like_article: "Những người thích bài viết của bạn.",
  message_delete: "Tin nhắn này đã bị xóa.",
  message_edited: "đã sửa",
  edit_message: "Chỉnh sửa tin nhắn",
  edit_window_expired: "Tin nhắn chỉ có thể được chỉnh sửa trong vòng 10 phút sau khi gửi.",
  message_edit_save: "Lưu",
  copy: "Sao chép",
  bookmark: "Đánh dấu",
  add_reaction: "Thêm cảm xúc",
  delete_message: "Xóa tin nhắn",
  more_options: "Thêm tùy chọn",
  info: "Thông tin",
  link_invite: "Mời qua liên kết",
  ll_nkk: "Mời đến Kjuup",
  selected: "Đã chọn",
  is_active: "Hoạt động",
  inactive: "Không hoạt động",
  last_online: "truy cập lần cuối {{when}}",
  remove_user_l: "Xóa",
  link_expire: "Mỗi liên kết được tạo sẽ có hiệu lực trong 72 giờ.",
  company_language: "Ngôn ngữ công ty",
  company_language_info: "Lựa chọn ngôn ngữ sẽ được sử dụng cho tất cả các xác nhận email liên quan đến công ty.",
  s_image: "hình ảnh",
  m_image: "hình ảnh",
  removeMsg: "Nhấn để xóa",
  block: 'Chặn',
  unblock: 'Bỏ chặn',
  blocks: 'Bạn có chắc chắn muốn chặn người dùng này không?',
  unblocks: 'Bạn có chắc chắn muốn bỏ chặn người dùng này không?',
  bolcked_click_un_block: 'Bạn đã chặn liên hệ này. Nhấp vào đây để xóa chặn.',
  you_have_unblocked: 'Bạn đã bỏ chặn liên hệ này.',
  you_have_blocked: 'Bạn đã chặn liên hệ này.',
  unblock_to_send: 'Bỏ chặn người dùng để gửi tin nhắn.',
  pilot_text: "AI chuyên biệt cho các chủ đề xây dựng",
  startup_screen_label: "Màn hình khởi động",
  startup_screen_info: "Chọn màn hình mở khi khởi động Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Tin nhắn",
  startup_screen_saved: "Đã cập nhật màn hình khởi động",
email_on: "Thông báo email trò chuyện",
  email_on_grp: "Thông báo email",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Kích hoạt hoặc vô hiệu hóa thông báo email cho dự án này. Tùy chọn này chỉ có sẵn khi \"Thông báo email trò chuyện\" được bật qua cài đặt cá nhân.",
  todo_notification_info: "Bạn sẽ được thông báo mỗi khi có một nhiệm vụ mới được giao cho bạn.",
  info_val: "Bạn sẽ nhận được email nếu một tin nhắn trò chuyện mới không được đọc trong thời gian ngắn. Bạn có thể tắt tính năng này cho từng dự án hoặc cuộc trò chuyện trong cài đặt của chúng hoặc trong thông tin nhóm trò chuyện.",
  email_groups: "Kích hoạt hoặc vô hiệu hóa thông báo email cho trò chuyện này. Tùy chọn này chỉ có sẵn khi \"Thông báo email trò chuyện\" được bật qua cài đặt cá nhân và dự án.",
  add_update_email: "Thêm/Cập nhật Email",
  text_to_verifiy: "Tùy chọn \"Thông báo email trò chuyện\" chỉ có thể được bật nếu bạn có địa chỉ email đã xác minh trong hồ sơ.",
  stored_email: "Email đã lưu: ",
  verify_email: "Xác nhận đang chờ!",
  join_call: "Tham gia",
  call_is_started: "Cuộc gọi đã bắt đầu",
  start_chat: "Bắt đầu trò chuyện trực tiếp?",
  project_rooms: "Dự án",
  download_selected: "Tải xuống",
  add_employee_confirm: 'Bạn có chắc chắn muốn thêm người dùng này vào công ty không?',
  invalid_deeplink: "URL deeplink không hợp lệ. Thiếu các tham số bắt buộc.",
  deeplink_error: "Không thể xử lý deeplink. Vui lòng thử lại sau.",
  reply: "Trả lời",
  reply_enter: "Nhập trả lời...",
  reply_sent_successfully: "Trả lời đã được gửi thành công",
  reply_failed: "Gửi trả lời thất bại",
  reply_failed_generic: "Gửi trả lời thất bại. Vui lòng thử lại.",
  replying_to_message: "Đang trả lời tin nhắn",
  cancel_reply: "Hủy trả lời",
  voice_message: "Tin nhắn thoại",
  send: "Gửi",
  cancel: "Hủy",
  type_your_reply: "Nhập trả lời của bạn...",
  suggested_replies: "Trả lời được đề xuất",
  suggestions_error: "Tải đề xuất thất bại",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Vui lòng đợi một chút. Văn bản của bạn đang được chuẩn bị riêng cho bạn.",
  loading_chat_message: "Đang tải trò chuyện...",
  extracting_message: "Đang trích xuất tin nhắn...",
  create_todo: "Tạo ToDo",
  create_todo_confirmation: "Bạn có muốn tạo ToDo từ tin nhắn này không?",
  select_project_required: "Vui lòng chọn dự án/nhóm",
  only_assigned_can_change_status: "Chỉ người dùng được chỉ định mới có thể thay đổi trạng thái",
  todo_summary: "Tóm tắt",
  todo_summary_placeholder: "Nhập tóm tắt todo...",
  todo_date: "Ngày",
  todo_time: "Thời gian",
  todo_date_hint: "Để trống để sử dụng ngày/giờ tin nhắn gốc",
  todo_created_success: "ToDo đã được tạo thành công",
  todo_creation_failed: "Tạo ToDo thất bại",
  create: "Tạo",
  image: "hình ảnh",
  images: "hình ảnh",
  remove_all_images: "Xóa tất cả hình ảnh",
  remove_image: "Xóa hình ảnh",
  remove_document: "Xóa tài liệu",
  remove_recording: "Xóa bản ghi",
  play_recording: "Phát bản ghi",
  upload_image: "Tải lên hình ảnh",
  upload_document: "Tải lên tài liệu",
  record_audio: "Ghi âm",
  stop_recording: "Dừng ghi âm",
  stop_recording_text: "Dừng ghi âm",
  please_remove_current_attachment: "Vui lòng xóa tệp đính kèm hiện tại để",
  please_upload_image_file: "Vui lòng tải lên tệp hình ảnh hợp lệ",
  please_upload_valid_document: "Vui lòng tải lên tệp tài liệu hợp lệ",
  searching_messages: "Đang tìm kiếm tin nhắn...",
  loading_more: "Đang tải thêm...",
  loading_more_users: "Đang tải thêm người dùng...",
  load_more_users: "Tải thêm người dùng",
  no_more_users_to_load: "Không còn người dùng để tải",
  no_messages_found: "Không tìm thấy tin nhắn",
  try_different_keyword: "Thử từ khóa khác hoặc kiểm tra chính tả.",
  search_messages: "Tìm kiếm tin nhắn, nhóm trò chuyện, dự án và người dùng...",
  todo: "ToDo",
  np_todo: "Không có ToDo",
  move_to_todo: "Lưu dưới dạng ToDo",
  remove_todo: "Bạn có thực sự muốn xóa ToDo không?",
  remove_all_todo: "Xóa tất cả ToDo",
  remove_all_todo_confirm: "Bạn có thực sự muốn xóa tất cả ToDo không?",
  add_to_todo: "Thêm vào ToDo",
  remove_from_todo: "Xóa khỏi ToDo",
  confirm: "Xác nhận",
  ok: "Ok",
  read_more: "Đọc thêm",
  show_less: "Hiển thị ít hơn",
  show_more: "Hiển thị thêm",
  audio: "Âm thanh",
  video: "Video",
  notification_schedule: "Lịch thông báo",
  notification_schedule_desc: "Bạn sẽ chỉ nhận thông báo đẩy và email trong các giờ bạn chọn. Ngoài những thời điểm đó, chúng sẽ bị tạm dừng.",
  learn_more: "Tìm hiểu thêm",
  allow_notifications: "Cho phép thông báo:",
  every_day: "Mỗi ngày",
  weekdays: "Ngày trong tuần (Thứ Hai đến Thứ Sáu)",
  custom: "Tùy chỉnh",
  monday: "Thứ Hai",
  tuesday: "Thứ Ba",
  wednesday: "Thứ Tư",
  thursday: "Thứ Năm",
  friday: "Thứ Sáu",
  saturday: "Thứ Bảy",
  sunday: "Chủ Nhật",
  to: "đến",
  notification_settings: "Thông báo",
  notification_settings_saved: "Cài đặt thông báo đã được lưu thành công",
  notification_settings_error: "Lưu cài đặt thông báo thất bại",
  unavailability_note: "Thông báo vắng mặt",
  unavailability_description: "Đặt thông báo vắng mặt. Khi được kích hoạt, thông báo sẽ hiển thị cho người khác trong tất cả các cuộc trò chuyện và thông báo sẽ bị tạm dừng.",
  unavailability_start_date: "Ngày bắt đầu",
  unavailability_end_date: "Ngày kết thúc",
  unavailability_message: "Tin nhắn",
  unavailability_message_hint: "Sử dụng {endDate} làm chỗ giữ chỗ cho ngày trở lại của bạn.",
  unavailability_replacement: "Liên hệ thay thế",
  unavailability_replacement_placeholder: "Nhập ID người dùng cho yêu cầu khẩn cấp",
  unavailability_replacement_current: "Người thay thế hiện tại",
  unavailability_replacement_hint: "Nếu được đặt, một liên kết để liên hệ người này cho các vấn đề khẩn cấp sẽ được hiển thị trong thông báo vắng mặt của bạn.",
  unavailability_replacement_none: "Không có người thay thế (tùy chọn)",
  unavailability_contact_urgent: "Cho yêu cầu khẩn cấp liên hệ",
  unavailability_default_message: "Tôi hiện không có mặt tại văn phòng và không có quyền truy cập Kjuup. Tôi sẽ có mặt trở lại từ {endDate} và sẽ liên hệ lại với bạn.",
  unavailability_save: "Lưu",
  unavailability_deactivate: "Hủy kích hoạt",
  unavailability_active_until: "Hoạt động đến",
  unavailability_saved: "Thông báo vắng mặt đã được lưu",
  unavailability_save_error: "Lưu thông báo vắng mặt thất bại",
  unavailability_deactivated: "Thông báo vắng mặt đã bị hủy kích hoạt",
  unavailability_end_date_required: "Ngày kết thúc là bắt buộc",
  start_time_before_end_time: "Thời gian bắt đầu phải trước thời gian kết thúc",
  loading: "Đang tải",
  disabled: "Đã tắt",
  enable: "Bật",
  disable: "Tắt",
  forwarded: "Đã chuyển tiếp",
  message_forwarded: "Tin nhắn đã được chuyển tiếp!",
  schedule_article_post: "Lên lịch đăng bài viết",
  date: "Ngày",
  time: "Thời gian",
  scheduled_for_publication: "Đã lên lịch xuất bản",
  article_will_be_published_on: "Bài viết sẽ được xuất bản vào:",
  reset_selection: "Đặt lại lựa chọn",
  continue: "Tiếp tục",
  cancel: "Hủy",
  error_loading_members: "Lỗi tải thành viên",
  please_fill_all_fields: "Vui lòng điền tất cả các trường",
  invalid_email: "Địa chỉ email không hợp lệ",
  member_added_successfully: "Thành viên đã được thêm thành công",
  error_onboarding_user: "Lỗi thêm người dùng",
  error_creating_chat: "Lỗi tạo trò chuyện",
  error_creating_group: "Lỗi tạo nhóm",
  new_group: "Nhóm mới",
  please_select_or_enter_group_name: "Vui lòng chọn nhóm hoặc nhập tên nhóm",
  please_select_or_enter_room_name: "Vui lòng chọn dự án hoặc nhập tên dự án",
  error_creating_room: "Lỗi tạo dự án",
  error_opening_chat: "Lỗi mở trò chuyện",
  privacy_modal_text: "Chỉ chọn \"Riêng tư\" nếu trò chuyện không chứa nội dung chuyên nghiệp liên quan cho người quản lý dự án.",
  not_private: "Không riêng tư",
  private: "Riêng tư",
  error_loading_groups: "Lỗi tải nhóm",
  automatic_chat_export: "Xuất trò chuyện tự động",
  automatic_chat_export_info: "Sau khi kích hoạt, lịch sử trò chuyện sẽ được tự động gửi đến địa chỉ email được chỉ định mỗi tháng.",
  automatic_chat_export_no_email: "Để kích hoạt xuất trò chuyện tự động, bạn cần thêm địa chỉ email trước. Bạn có thể thêm địa chỉ email của mình trong cài đặt cá nhân.",
  enter_email: "Nhập Email",
  update: "Cập nhật",
  confirm: "Xác nhận",
  export_to_email: "Xuất sẽ được gửi đến Email sau.",
  start_chat_button: "Tin nhắn mới",
  matching_existing_chats: "Khớp với trò chuyện hiện có",
  subject: "Chủ đề",
  add_subject: "Thêm chủ đề",
  chat_subject: "Chủ đề trò chuyện:",
  set_project_room: "Đặt dự án",
  matching_existing_project_rooms: "Khớp với dự án hiện có",
  name_project_room: "Đặt tên dự án",
  professional_or_private: "Chuyên nghiệp hoặc riêng tư",
  professional: "Chuyên nghiệp",
  privacy_modal_text_updated: "Chỉ chọn \"Riêng tư\" nếu trò chuyện không chứa nội dung chuyên nghiệp liên quan cho người quản lý dự án. Trò chuyện riêng tư không hiển thị cho người quản lý dự án.",
  create_internal_chat: "Trò chuyện bên ngoài - hay nội bộ?",
  internal_chat_description: "Chỉ nhân viên của công ty bạn mới có thể được thêm vào trò chuyện nội bộ.",
  yes: "Có",
  no: "Không",
  chat_is_being_created: "Đang tạo trò chuyện...",
  discard_article_confirm: "Bạn có thực sự muốn hủy các thay đổi đối với bài viết này không?",
  please_enter_article_title: "Vui lòng nhập tiêu đề bài viết trước.",
  please_add_mandatory_fields: "Vui lòng thêm tất cả các trường bắt buộc",
  product_label: "Sản phẩm:",
  no_companies_found: "Không tìm thấy công ty",
  visible_to_all_followers: "Hiển thị cho tất cả thành viên Kjuup",
  only_visible_to_employees: "Chỉ hiển thị cho nhân viên",
  something_went_wrong: "Đã xảy ra lỗi, vui lòng thử lại",
  please_select_department: "Vui lòng chọn phòng ban/vị trí",
  schedule: "Lên lịch",
  please_select_future_date_time: "Vui lòng chọn ngày và giờ trong tương lai để lên lịch bài viết.",
  please_select_different_date_time: "Vui lòng chọn ngày hoặc giờ khác để lên lịch bài viết.",
  please_select_later_time: "Vui lòng chọn thời gian muộn hơn thời gian hiện tại cho hôm nay.",
  unpin_article: "Bỏ ghim bài viết",
  pin_article: "Ghim bài viết",
  and: "và",
  others: "khác",
  at: "tại",
  mute: "Tắt tiếng",
  unmute: "Bật tiếng",
  chat_muted_successfully: "Đã tắt tiếng trò chuyện thành công",
  chat_unmuted_successfully: "Đã bật tiếng trò chuyện thành công",
  mute_chat_confirm: "Bạn có thực sự muốn tắt tiếng trò chuyện này không? Bạn sẽ không còn nhận được thông báo cho tin nhắn mới.",
  unmute_chat_confirm: "Bạn có thực sự muốn bật tiếng trò chuyện này không? Bạn sẽ lại nhận được thông báo cho tin nhắn mới.",
  please_select_group_to_forward: "Vui lòng chọn nhóm để chuyển tiếp tin nhắn",
  record_not_found: "Không tìm thấy bản ghi!",
  please_select_position: "Vui lòng chọn vị trí",
  delete_article_confirm: "Bạn có chắc chắn muốn xóa bài viết này không?",
  delete_company_service_confirm: "Bạn có chắc chắn muốn xóa dịch vụ công ty không?",
  block_translation_confirm: "Bạn có thực sự muốn chặn dịch tự động trong dự án cho tất cả thành viên của công ty",
  unblock_translation_confirm: "Bạn có thực sự muốn bỏ chặn dịch tự động trong dự án cho tất cả thành viên của công ty",
  please_select_file: "Vui lòng chọn tệp để tải lên",
  role_in_building_industry: "Vai trò trong ngành xây dựng*",
  invalid_email_address: "Địa chỉ email không hợp lệ",
  please_enter_password: "Vui lòng nhập mật khẩu",
  password_change_email_sent: "Một email đã được gửi đến email Kjuup của bạn. Vui lòng xác nhận mật khẩu mới bằng cách nhấp vào liên kết xác nhận trong email.",
  please_enter_username: "Vui lòng nhập tên người dùng",
  username_same_as_before: "Tên người dùng không thể giống như trước",
  profile_deleted_successfully: "Hồ sơ đã được xóa thành công",
  hardware_requirements: "Yêu cầu phần cứng",
  hardware_requirements_list: "• 4GB RAM<br/>• Tốc độ CPU tối thiểu 2GHz<br/>• Windows 7 trở lên / tất cả phiên bản macOS",
  submitting: "Đang gửi...",
  signing_in: "Đang đăng nhập...",
  please_enter_service_name: "Vui lòng nhập tên dịch vụ",
  something_went_wrong_error: "Ồ! Đã xảy ra lỗi...",
  something_went_wrong_try_again: "Xin lỗi, đã xảy ra lỗi ở đó. Thử lại",
  position_label: "Vị trí:",
  loading_room: "Đang tải dự án...",
  navigating_to_room: "Đang điều hướng đến dự án",
  loading_chat: "Đang tải trò chuyện...",
  translate: "Dịch",
  show_original: "Hiển thị bản gốc",
  saving: "Đang lưu...",
  language_selection_info: "Lựa chọn ngôn ngữ được sử dụng cho tất cả các xác nhận email liên quan đến công ty.",
  nav_call: "Cuộc gọi",
  nav_home: "Trang chủ",
  nav_messages: "Tin nhắn",
  nav_todo: "Việc cần làm",
  nav_rooms: "Dự án",
  nav_all_rooms: "Tất cả dự án",
  pinned_rooms_max: "Bạn có thể ghim tối đa 10 dự án.",
  pinned_room_unpin: "Bỏ ghim",
  pinned_rooms_drop: "Kéo dự án của bạn vào đây để chọn nhanh",
  nav_profile: "Hồ sơ",
  nav_company: "Công ty",
  nav_company_documents: "Tài liệu",
  nav_logout: "Đăng xuất",
  add_member_title: "Thêm thành viên",
  continue_btn: "Tiếp tục",
  search_placeholder: "Tìm kiếm",
  no_members_found: "Không tìm thấy thành viên",
  no_groups_found: "Không tìm thấy nhóm",
  no_rooms_found: "Không tìm thấy dự án",
  search_users_tab: "Người dùng",
  search_documents_tab: "Tài liệu",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Không có tệp",
  no_documents_available: "No documents",
  searching_users: "Đang tìm kiếm người dùng...",
  no_users_found: "Không tìm thấy người dùng",
  search_emails_tab: "Email",
  searching_emails: "Đang tìm email...",
  no_emails_found: "Không tìm thấy email",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Nhóm không tên",
  unnamed_room: "Dự án không tên",
  all_members: "Tất cả",
  room_label: "Dự án:",
  subject_label: "Chủ đề:",
  no_members: "Không có thành viên",
  creating_structure: "Đang tạo cấu trúc của bạn",
  opening_chat: "Đang mở trò chuyện",
  please_wait: "Vui lòng đợi...",
  loading_todo: "Đang tải ToDo...",
  task_updated: "Nhiệm vụ đã được cập nhật",
  error_updating_task: "Lỗi cập nhật nhiệm vụ",
  task_deleted: "Nhiệm vụ đã bị xóa",
  error_deleting_task: "Lỗi xóa nhiệm vụ",
  delete_task_confirm: "Bạn có chắc chắn muốn xóa nhiệm vụ này không?",
  description_label: "Mô tả",
  description_placeholder: "Nhập mô tả...",
  date_time_label: "Ngày & Giờ",
  save_hint: "Ctrl+Enter để lưu, Esc để hủy",
  edit_label: "Chỉnh sửa",
  delete_label: "Xóa",
  todo_list_title: "Việc cần làm",
  tasks_count: "nhiệm vụ",
  search_placeholder_todo: "Tìm kiếm...",
  select_task_to_open_chat: "Chọn nhiệm vụ để mở trò chuyện",
  today: "Hôm nay",
  yesterday: "Hôm qua",
  time_suffix: "",
  from_chat: "ToDo nguồn",
  assigned_to: "Được giao cho",
  assign_users: "Giao người dùng",
  no_users_assigned: "Không có người dùng được giao",
  assign: "Giao",
  assign_to: "Giao cho...",
  navigate_to_chat: "Điều hướng đến trò chuyện",
  navigate_to_email: "Điều hướng đến email",
  show_original_message: "Hiển thị nguồn",
  hide_original_message: "Ẩn nguồn",
  status_pending: "Đang chờ",
  status_in_progress: "Đang tiến hành",
  status_completed: "Hoàn thành",
  show: "Hiển thị",
  close: "Đóng",
  // Log translations
  status_confirmed: "[Đã xác nhận]",
  log_todo_created: "ToDo [đã tạo]",
  log_todo_confirmed: "ToDo [đã xác nhận]",
  log_todo_deleted: "ToDo [đã xóa]",
  log_todo_updated: "ToDo [đã cập nhật]",
  log_description_updated: "[Mô tả đã cập nhật]",
  log_deadline_updated: "[Hạn chót đã cập nhật]",
  log_assigned_to: "[Đã giao cho] {name}",
  log_unassigned_from: "[Đã hủy giao từ] {name}",
  log_assignment_added: "[Đã thêm phân công]: {name}",
  log_assignment_removed: "[Đã xóa phân công]: {name}",
  log_status_updated: "[Trạng thái đã thay đổi từ] {from} [sang] {to}",
  log_status_changed: "[Trạng thái đã thay đổi]",
  log_status_changed_to: "[Trạng thái đã thay đổi thành] {status}",
  log_changed_status_to: "[Đã thay đổi trạng thái thành]:",
  log_for_user: "[cho người dùng]:",
  log_user_updated_status: "[Người dùng đã cập nhật trạng thái todo của họ]",
  log_changed_date_to: "[Đã thay đổi ngày thành]:",
  log_changed_description_to: "[Đã thay đổi mô tả thành]:",
  log_moved_to: "[Đã chuyển đến] {status}",
  todo_status_updated_from: "[từ]",
  todo_status_updated_to: "[sang]",
  filter_pending: "Đang chờ",
  filter_confirmed: "Đã xác nhận",
  filter_assigned_to_me: "Nhiệm vụ của tôi",
  filter_assigned_by_me: "Đã ủy quyền",
  todo_project_label: "Dự án:",
  assigned_users: "Người dùng được giao:",
  todo_chat_label: "Trò chuyện:",
  history: "Lịch sử",
  todo_assigned_by: "Được giao bởi:",
  todo_assigned_push: "ToDo đã giao:",
  todo_assigned_push_empty: "Một ToDo mới đã được giao cho bạn.",
  search_groups: "Nhóm",
  search_chat_groups: "Nhóm trò chuyện",
  search_project_room: "Dự án",
  search_messages_tab: "Tin nhắn",
  searching_groups: "Đang tìm nhóm...",
  searching_rooms: "Đang tìm dự án...",
  no_groups_found: "Không tìm thấy nhóm nào",
  no_rooms_found: "Không tìm thấy dự án nào",
  create_poll: "Bình chọn",
  poll_question_label: "CÂU HỎI",
  poll_question_placeholder: "Đặt câu hỏi",
  poll_options_label: "TÙY CHỌN",
  poll_option: "Tùy chọn",
  poll_add_option: "Thêm tùy chọn",
  poll_allow_multiple: "Cho phép nhiều lựa chọn",
  poll_multiple_allowed: "Chọn một hoặc nhiều tùy chọn",
  poll_select_option: "Chọn một tùy chọn",
  poll_view_votes: "Xem phiếu bầu",
  poll_vote_singular: "phiếu",
  poll_vote_plural: "phiếu",
  poll_votes: "Kết quả bình chọn",
  poll_no_votes_yet: "Chưa có phiếu nào",
  transcript_step_processing: "Đang phiên âm...",
  ai_transcript_tab: "AI-Phiên âm",
  ai_transcript_info: "Chỉ khả dụng cho tin nhắn thoại được tạo sau ngày 09.03.2026.",
  transcript_more: "...xem thêm",
  transcript_less: "...thu gọn",
  ki_transcript_voice_message: "KI-Bản ghi âm tin nhắn thoại",
  ki_image_analysis: "Phân tích hình ảnh bằng AI",
  type_message: "Nhập tin nhắn",
  email_tab_messages: "Tin nhắn",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Tài khoản email",
  email_connect_gmail: "Kết nối Gmail",
  email_connect_outlook: "Kết nối Outlook",
  email_no_accounts: "Chưa có tài khoản email được kết nối",
  email_no_accounts_hint: "Kết nối tài khoản email trong cài đặt hồ sơ của bạn",
  email_no_messages: "Không có email",
  email_from: "Từ",
  email_to: "Đến",
  email_subject: "Chủ đề",
  email_disconnect: "Ngắt kết nối",
  email_disconnect_confirm: "Bạn có chắc chắn muốn ngắt kết nối tài khoản email này không? Tất cả email đã đồng bộ sẽ bị xóa.",
  email_account_disconnected: "Đã ngắt kết nối tài khoản email thành công",
  email_account_disconnect_failed: "Không thể ngắt kết nối tài khoản",
  email_connecting: "Đang kết nối...",
  email_account_connected: "Kết nối tài khoản thành công",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Đi đến Cài đặt",
  email_date: "Ngày",
  email_reply: "Trả lời",
  email_forward: "Chuyển tiếp",
  email_copy_text: "Sao chép văn bản",
  email_text_copied: "Đã sao chép!",
  email_text_copy_failed: "Không thể sao chép văn bản.",
  email_delete: "Xóa",
  email_not_spam: "Không phải spam",
  email_not_spam_success: "Email đã được chuyển vào hộp thư đến.",
  email_not_spam_failed: "Không thể chuyển vào hộp thư đến.",
  email_delete_confirm: "Bạn có chắc chắn muốn xóa email này không?",
  email_delete_from_folder: "Bạn có chắc chắn muốn xóa khỏi {folder} không?",
  email_delete_permanent_from_folder:
    "Bạn có chắc chắn muốn xóa vĩnh viễn khỏi {folder} không? Hành động này không thể hoàn tác.",
  email_save_draft_confirm: "Bạn có muốn lưu email này làm bản nháp không?",
  email_save_draft: "Lưu bản nháp",
  email_discard: "Bỏ",
  email_back_to_compose: "Quay lại soạn thảo",
  email_draft_saved: "Đã lưu bản nháp.",
  email_draft_save_failed: "Không thể lưu bản nháp.",
  email_loading: "Đang tải email...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Chọn",
  email_attachment_singular: "Tệp đính kèm",
  email_attachment_plural: "Tệp đính kèm",
  email_back: "Quay lại",
  email_download: "Tải xuống",
  email_close: "Đóng",
  email_preview: "Xem trước",
  email_preview_not_available: "Không thể xem trước",
  email_preview_failed: "Không thể xem trước",
  select_attachments: "Chọn tệp đính kèm",
  email_loading_preview: "Đang tải bản xem trước...",
  email_mark_unread_failed: "email không thể đánh dấu là chưa đọc.",
  email_delete_failed: "email không thể xóa.",
  filter_all: "Tất cả",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Tin nhắn trực tiếp",
  my_notes: "My Space",
  filter_internal_groups: "Trò chuyện nhóm nội bộ",
  filter_external_groups: "Trò chuyện nhóm bên ngoài",
  filter_group_chats: "Trò chuyện nhóm",
  filter_groups_internal: "Nội bộ",
  filter_groups_external: "Bên ngoài",
  filter_unread_only: "Chỉ chưa đọc",
  room_daily_briefing_info: "Khi bật, báo cáo cho dự án này được tạo mỗi 24 giờ vào thời điểm đã chỉ định trong cài đặt cá nhân — nhưng chỉ khi có hoạt động trong khoảng thời gian đó.",
  email_select_all: "Chọn tất cả",
  email_deselect_all: "Bỏ chọn tất cả",
  email_reply_all: "Trả lời tất cả",
  email_reply_placeholder: "Nhập câu trả lời...",
  email_forward_placeholder: "Thêm tin nhắn...",
  email_edit_draft: "Chỉnh sửa bản nháp",
  email_attach: "Đính kèm",
  email_attachment_from_original: "Từ tin nhắn gốc",
  email_remove: "Xóa",
  email_drop_files: "Thả tệp để đính kèm",
  email_loading_attachments: "Đang tải tệp đính kèm...",
  email_archive: "Lưu trữ",
  mark_unread: "Đánh dấu chưa đọc",
  mark_read: "Đánh dấu đã đọc",
  email_all_accounts: "Tất cả tài khoản",
  email_error: "Lỗi",
  email_delete_email_failed: "Xóa email thất bại.",
  enter_url: "Nhập URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Đăng ký ngay',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: 'DÙNG THỬ MIỄN PHÍ 1 THÁNG',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Hôm nay không thanh toán. Không yêu cầu thông tin thẻ tín dụng trước khi gói trả phí bắt đầu.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Quản lý tất cả tài khoản email ngay trong Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI soạn câu trả lời – bạn chỉ cần xác nhận',
  kjuup_io_feature_tasks: 'Công việc & lịch luôn được cập nhật tự động',
  kjuup_io_choose_plan: 'Chọn gói',
  kjuup_io_plan_monthly: 'Hàng tháng',
  kjuup_io_plan_yearly: 'Hàng năm',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Bảo mật bởi Stripe · hủy bất cứ lúc nào',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Đã nhận thanh toán. Đang kích hoạt gói đăng ký của bạn…',
  kjuup_io_toast_activating_soon: 'Đã nhận thanh toán. Gói đăng ký của bạn sẽ sớm được kích hoạt.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Còn {count} giờ',
  kjuup_io_trial_left_hour: 'Còn 1 giờ',
  kjuup_io_trial_left_minutes: 'Còn {count} phút',
  kjuup_io_trial_left_minute: 'Còn 1 phút',
  kjuup_io_trial_left_seconds: 'Còn {count} giây',
  kjuup_io_trial_left_second: 'Còn 1 giây',
  kjuup_io_trial_ending_now: 'Thời gian dùng thử đang kết thúc…',
  kjuup_io_request_timeout: 'Kết nối đã hết thời gian chờ. Vui lòng thử lại.',
  kjuup_io_info_days_free: '{days} ngày hoàn toàn miễn phí – gói đăng ký chỉ bắt đầu sau thời gian dùng thử.',
  kjuup_io_discount_total: 'Giảm giá của bạn: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Cá nhân: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Đóng',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Thời gian dùng thử miễn phí của bạn đã kết thúc',
  kjuup_io_trial_ended_body: 'Đăng ký Kjuup.io để tiếp tục sử dụng email và các tính năng cao cấp khác.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Thời gian dùng thử miễn phí của bạn đã bắt đầu',
  kjuup_io_toast_trial_fail: 'Không thể bắt đầu dùng thử miễn phí',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / tháng',
  kjuup_io_save_amount_year: 'Tiết kiệm {price} mỗi năm',
  kjuup_io_billed_annually_amount: '{price} thanh toán hàng năm',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Bạn nhận được:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Không cần thẻ tín dụng – bắt đầu ngay mà không cần dữ liệu thanh toán.',
  kjuup_io_info_cancel_anytime: 'Hủy bất cứ lúc nào – không ràng buộc, không rủi ro.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Chu kỳ thanh toán',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Đã lưu phương thức thanh toán. Bạn sẽ bị tính phí khi thời gian dùng thử kết thúc.',
  calendar_sync_info: 'Tự động đồng bộ tất cả ToDo của Kjuup với lịch của bạn.',
  calendar_no_accounts: 'Chưa có lịch nào được kết nối.',
  article_new_badge: 'MỚI',
  article_new_posts: '{0} bài đăng mới',
  documents: 'Tài liệu',
  add_documents: 'Thêm tài liệu',
  no_preview_available: 'Không có bản xem trước',
  no_preview_hint: 'Loại tệp này không thể xem trước, nhưng vẫn sẽ được gửi đi.',
  max_documents_reached: 'Bạn có thể đính kèm tối đa 10 tài liệu mỗi lần.',
  open_file: 'Mở tệp',
  twofa_title: 'Xác thực hai yếu tố',
  twofa_method_totp: 'Ứng dụng xác thực',
  twofa_method_sms: 'Tin nhắn SMS',
  twofa_method_email: 'Email',
  twofa_enter_app: 'Nhập mã gồm 6 chữ số từ ứng dụng xác thực.',
  twofa_enter_sms: 'Nhập mã gồm 6 chữ số chúng tôi đã gửi qua SMS.',
  twofa_enter_email: 'Nhập mã gồm 6 chữ số chúng tôi đã gửi tới email.',
  twofa_resend: 'Gửi lại mã',
  twofa_try_another: 'Thử cách khác',
  twofa_remember_device: 'Không hỏi lại trên thiết bị này trong 30 ngày',
  twofa_sent: 'Chúng tôi đã gửi một mã.',
  twofa_invalid_code: 'Mã không đúng. Vui lòng thử lại.',
  twofa_something_wrong: 'Đã xảy ra lỗi. Vui lòng thử lại.',
  twofa_method_unavailable: 'Phương thức xác minh này không khả dụng.',
  twofa_on_desc: 'Xác thực hai yếu tố đang bật. Bạn cần mã mỗi lần đăng nhập.',
  twofa_off_desc: 'Thêm bước thứ hai sau mật khẩu. Ứng dụng xác thực là lựa chọn an toàn nhất.',
  twofa_methods: 'Phương thức',
  twofa_on: 'Bật',
  twofa_add: 'Thêm',
  twofa_default_method: 'Phương thức mặc định',
  twofa_default: 'Mặc định',
  twofa_turn_off: 'Tắt',
  twofa_disable_hint: 'Nhập mật khẩu và mã hiện tại để tắt xác thực hai yếu tố.',
  twofa_disable_need: 'Nhập mật khẩu và mã xác minh.',
  twofa_code_placeholder: 'Mã 6 chữ số hoặc mã dự phòng',
  twofa_send_code: 'Gửi mã',
  twofa_primary_updated: 'Đã cập nhật phương thức mặc định.',
  twofa_disabled: 'Xác thực hai yếu tố đã được tắt.',
  twofa_enabled: 'Xác thực hai yếu tố đã được bật.',
  twofa_totp_help: 'Quét mã QR này bằng Google Authenticator, Authy hoặc 1Password. Bạn cũng có thể nhập khóa thủ công.',
  twofa_secret_copied: 'Đã sao chép khóa',
  twofa_sms_help: 'Nhập số điện thoại theo định dạng quốc tế. Chúng tôi sẽ gửi mã 6 chữ số qua SMS.',
  twofa_email_help: 'Chúng tôi sẽ gửi mã 6 chữ số tới email tài khoản.',
  twofa_backup_title: 'Mã dự phòng',
  twofa_backup_help: 'Lưu các mã dùng một lần này ở nơi an toàn. Mỗi mã dùng một lần nếu bạn mất điện thoại.',
  twofa_copy_codes: 'Sao chép mã',
  twofa_codes_copied: 'Đã sao chép mã dự phòng',
  twofa_regenerate: 'Lấy mã dự phòng mới',
  twofa_regenerate_hint: 'Thao tác này thay thế các mã dự phòng chưa dùng. Nhập mật khẩu và mã hiện tại.',
  twofa_backup_remaining: 'Còn {n} mã dự phòng chưa dùng',
  twofa_new_codes: 'Mã dự phòng mới',
  twofa_sms_unavailable: 'Mã tin nhắn chưa khả dụng.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Các việc Kjuup được giao cho bạn được sao chép vào dự án Kjuup trong Todoist. Thay đổi trên Todoist không được sao chép ngược lại.",
  todoist_connect: "Kết nối Todoist",
  todoist_connected: "Đã kết nối Todoist",
  todoist_connect_failed: "Kết nối Todoist thất bại",
  todoist_disconnect: "Ngắt kết nối",
  todoist_disconnected: "Đã ngắt kết nối Todoist",
  todoist_disconnect_confirm: "Ngắt kết nối Todoist? Việc đã có trong Todoist sẽ được giữ lại. Đồng bộ sẽ dừng.",
  todoist_sync_now: "Đồng bộ ngay",
  todoist_syncing: "Đang đồng bộ…",
  todoist_sync_done: "Đồng bộ xong",
  todoist_sync_failed: "Đồng bộ thất bại",
  todoist_auth_error: "Kết nối lại Todoist để tiếp tục đồng bộ.",
  todoist_last_sync: "Lần đồng bộ gần nhất",
  todoist_not_connected: "Chưa kết nối Todoist",
  todoist_auth_url_failed: "Không mở được trang ủy quyền Todoist.",
  recommend_text: "Tham gia Kjuup để luôn kết nối và giữ cho việc giao tiếp của bạn ngăn nắp. Gom các kênh của bạn về một chỗ, giữ tin nhắn trong đúng dự án và bắt đầu mỗi sáng với bản tóm tắt cùng các công việc của bạn – tất cả đồng bộ với những ứng dụng bạn đang dùng. Bắt đầu miễn phí:",
  pro_auth_signin_title: 'Chào mừng trở lại',
  pro_auth_signin_sub: 'Đăng nhập bằng email công việc của bạn.',
  pro_auth_email_or_username: 'Email hoặc tên người dùng',
  pro_auth_email_placeholder: 'ten@congty.de',
  pro_auth_forgot_password: 'Quên mật khẩu?',
  pro_auth_create_account: 'Tạo tài khoản',
  pro_auth_show_password: 'Hiện mật khẩu',
  pro_auth_hide_password: 'Ẩn mật khẩu',
  pro_auth_register_sub: 'Chúng tôi sẽ gửi cho bạn một liên kết để xác nhận email.',
  pro_auth_register_plus_sub: 'Chọn tên người dùng và mật khẩu. Tiếp theo bạn sẽ đặt mã PIN bảo mật.',
  pro_auth_check_credentials: 'Kiểm tra email và mật khẩu của bạn',
  pro_news_export_pdf: 'Xuất dưới dạng PDF',
  pro_news_pdf_failed: 'Không thể tạo tệp PDF.',
  pro_news_pdf_attachments: 'Tệp đính kèm',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Nhập email của bạn và chúng tôi sẽ gửi liên kết để đặt lại mật khẩu.',
  pro_auth_send_link: 'Gửi liên kết đặt lại',
  pro_auth_plus_reset: 'Đặt lại bằng mã PIN',
  pro_auth_show_pin: 'Hiện mã PIN',
  pro_auth_hide_pin: 'Ẩn mã PIN',
  v2_auth_plus_only: 'Chỉ Kjuup+',
  room_action_media: "Tệp",
  room_tab_overview: "Tổng quan",
  room_tab_history: "Lịch sử",
  chat_info_media: "Tệp",
  messages: "tin nhắn",
  pro_todo_project_required: "Vui lòng chọn một dự án",
  pro_todo_choose_project: "Nhiệm vụ này thuộc dự án nào?",
  cockpit_report_delete_confirm: "Xóa báo cáo hàng ngày này?",
  cockpit_report_deleted: "Đã xóa báo cáo hàng ngày",
  cockpit_tab_company: "Công ty",
  cockpit_bookmarked_priorities: "Công việc đã đánh dấu",
  cockpit_load_error: "Không thể tải bảng điều khiển.",
  cockpit_retry: "Thử lại",
  cockpit_yesterday: "Hôm qua",
  cockpit_greeting_morning: "Chào buổi sáng",
  cockpit_greeting_day: "Chào buổi chiều",
  cockpit_greeting_evening: "Chào buổi tối",
  cockpit_assistant_q_open: "Hôm nay có việc gì đang mở?",
  cockpit_assistant_q_summarize: "Tóm tắt cuộc trò chuyện {{room}}",
  cockpit_assistant_q_overdue: "Công việc nào đã quá hạn?",
  cockpit_assistant_new: "{{n}} mới",
  cockpit_assistant_important: "{{n}} quan trọng",
  cockpit_assistant_title: "Trợ lý Kjuup",
  cockpit_assistant_hint: "Chạm và hỏi",
  room_overview_priority_no_detail: "Báo cáo không có thêm chi tiết về hạng mục ưu tiên này.",
  room_overview_priority_from: "Nguồn: {{name}}",
  room_overview_priority_open_task: "Mở công việc",
  cockpit_priority_position: "Ưu tiên {{index}} / {{total}}",
  room_overview_today_title: "Quan trọng hôm nay",
  room_overview_all_tasks: "Tất cả",
  room_overview_tasks_empty: "Không có hạn chót hoặc công việc đang mở",
  room_overview_appointments_empty: "Không có cuộc hẹn sắp tới",
  room_overview_no_priorities: "Không có hạng mục ưu tiên nào đang mở trong báo cáo mới nhất.",
  cockpit_report_top5: "5 hạng mục ưu tiên hàng đầu",
  cockpit_report_todo_created: "Đã tạo công việc",
  cockpit_report_source_missing: "Không tìm thấy tin nhắn nguồn.",
  delete_bookmarked_priority_confirm: "Bạn có chắc muốn xóa công việc đã đánh dấu này không?",
  cockpit_report_create_todo: "Tạo công việc",
  cockpit_priorities_deleting: "Đang xóa …",
  cockpit_priorities_select: "Xóa nhiều mục",
  cockpit_report_none: "Không có mục nào.",
  cockpit_priorities_delete_confirm: "Bạn có chắc muốn xóa {count} công việc đã đánh dấu không?",
  cockpit_priorities_delete_failed: "Không thể xóa {count} công việc",
  cockpit_priorities_deleted: "Đã xóa {count} công việc",
  cockpit_priorities_selected: "Đã chọn {count}",
  cockpit_channel_connected: "Đã kết nối",
  cockpit_channel_not_connected: "Chưa kết nối",
  cockpit_channel_connect: "Kết nối",
  cockpit_channel_chat: "Trò chuyện Kjuup",
  cockpit_channel_active: "Đang bật",
  cockpit_channel_hidden: "Đã ẩn",
  cockpit_channel_enable: "Bật",
  cockpit_channel_email: "Email",
  cockpit_channel_check: "Kiểm tra kết nối",
  cockpit_channel_fix: "Kiểm tra",
  cockpit_channel_forward: "Địa chỉ chuyển tiếp",
  cockpit_channel_not_set_up: "Chưa thiết lập",
  cockpit_channel_set_up: "Thiết lập",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Mất kết nối",
  cockpit_channel_importing: "Đang nhập",
  cockpit_channel_removing: "Đang ngắt kết nối",
  cockpit_channel_reconnect: "Kết nối lại",
  cockpit_channels_title: "Kênh",
  cockpit_company_role_super_admin: "Quản trị viên công ty",
  cockpit_company_role_dept_admin: "Quản trị viên phòng ban",
  cockpit_company_role_member: "Nhân viên",
  cockpit_company_none: "Không tìm thấy công ty Kjuup+",
  cockpit_company_eyebrow: "Công ty",
  cockpit_company_inactive: "không hoạt động",
  cockpit_company_settings: "Cài đặt công ty",
  cockpit_company_employees: "Nhân viên",
  cockpit_company_internal_rooms: "Dự án nội bộ",
  cockpit_report_all_projects: "Tất cả dự án",
  cockpit_report_progress_emails: "Đang phân tích email",
  cockpit_report_progress_chats: "Đang phân tích tin nhắn trò chuyện",
  cockpit_report_progress_documents: "Đang phân tích tệp đính kèm và tài liệu",
  cockpit_report_progress_tasks: "Đang phân tích công việc",
  cockpit_report_progress_summarizing: "Đang phân tích nội dung",
  cockpit_report_progress_reading: "Đang dùng lại nội dung đã phân tích",
  cockpit_report_progress_collecting: "Đang thu thập email, trò chuyện và công việc từ các dự án của bạn",
  cockpit_report_progress_priorities: "Đang tổng hợp hạng mục ưu tiên, thời hạn và quyết định",
  cockpit_report_progress_queued: "Đang chuẩn bị báo cáo",
  cockpit_report_creating_title: "Báo cáo hàng ngày của bạn đang được chuẩn bị",
  cockpit_report_progress_count_one: "Đã phân tích 1 mục",
  cockpit_report_progress_count_many: "Đã phân tích {{count}} mục",
  cockpit_report_progress_hint: "Thường mất một đến hai phút – trong lúc đó bạn có thể tiếp tục dùng bảng điều khiển.",
  cockpit_report_time_hint: "Báo cáo hàng ngày được tạo mỗi ngày lúc {{hour}}:00 cho năm dự án hoạt động nhiều nhất.",
  room_overview_priorities_title: "Tình trạng hiện tại và ưu tiên",
  room_overview_as_of: "Tính đến {{time}}",
  cockpit_report_delete: "Xóa báo cáo hàng ngày",
  email_tag_daily_briefing: "Báo cáo hàng ngày",
  cockpit_report_unread: "Mới",
  cockpit_report_clear_project: "Hiện tất cả dự án",
  cockpit_filter_project: "Dự án",
  cockpit_filter_all_projects: "Tất cả dự án",
  cockpit_report_recreate: "Tạo lại báo cáo hàng ngày",
  cockpit_report_hide_previous: "Ẩn báo cáo hàng ngày trước đó",
  cockpit_report_show_previous: "Hiện báo cáo hàng ngày trước đó",
  cockpit_report_room_empty: "Dự án này chưa có báo cáo hàng ngày",
  cockpit_report_empty: "Chưa có báo cáo hàng ngày",
  cockpit_report_room_empty_hint: "Chỉ tạo báo cáo hàng ngày cho dự án này.",
  cockpit_report_needs_mailbox: "Hãy kết nối tài khoản email để Kjuup có thể tạo báo cáo hàng ngày kèm công việc tự động.",
  cockpit_report_create: "Tạo báo cáo hàng ngày",
  cockpit_email_connect: "Kết nối email",
  cockpit_email_none_title: "Chưa kết nối tài khoản email",
  cockpit_email_none_reports: "Kết nối hộp thư để Kjuup gán email đến vào các dự án của bạn và tạo báo cáo hàng ngày kèm công việc.",
  cockpit_email_none_client: "Kết nối Gmail, Outlook hoặc IMAP để đọc, gán và trả lời email trực tiếp trong Kjuup.io.",
  cockpit_email_reports_title: "Ứng dụng email hiện tại",
  cockpit_email_reports_text: "Không có hộp thư đến trong Kjuup.io · {{rooms}} dự án có báo cáo hàng ngày lúc {{hour}}:00 · email đến được gán vào các dự án của bạn.",
  cockpit_email_reports_rooms: "Quản lý dự án",
  cockpit_email_settings: "Cài đặt email",
  cockpit_email_error_title: "Kiểm tra kết nối",
  cockpit_email_client_title: "Đã kết nối hộp thư đến",
  cockpit_email_accounts_n: "Đã kết nối {{n}} tài khoản",
  cockpit_email_last_sync: "đồng bộ lần cuối {{when}}",
  cockpit_email_report_at: "Báo cáo hàng ngày lúc {{hour}}:00",
  cockpit_email_open_inbox: "Mở hộp thư đến",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Địa chỉ email đã kết nối",
  email_folder_sent: "Thư đã gửi",
  email_no_subject: "(Không có tiêu đề)",
  cockpit_email_detail_loading: "Đang tải email …",
  cockpit_email_detail_failed: "Không thể tải email.",
  cockpit_email_detail_empty: "Email này không có nội dung.",
  cockpit_personal_settings: "Cài đặt cá nhân",
  cockpit_companies: "Công ty",
  cockpit_title: "Bảng điều khiển",
  cockpit_back: "Quay lại tổng quan",
  cockpit_day_overview: "Một ngày của bạn trong tầm mắt",
  email_saved_to_project: "Đã lưu email vào dự án",
  email_classify_need_project: "Vui lòng nhập tên dự án",
  cockpit_email_deleted: "Đã xóa email",
  cockpit_email_sent_empty: "Chưa có email đã gửi.",
  cockpit_email_incoming_empty: "Chưa có email đến.",
  cockpit_email_incoming_title: "Email",
  cockpit_email_incoming_sub: "Gán email đến và đã gửi vào các dự án của bạn. Bạn có thể điều chỉnh việc gán tại đây.",
  cockpit_email_incoming_unassigned_n: "{{n}} chưa gán",
  cockpit_email_folder_inbox: "Hộp thư đến",
  cockpit_email_folder_sent: "Đã gửi",
  cockpit_email_open: "Mở email",
  cockpit_email_incoming_suggested: "Đề xuất: {{room}}",
  cockpit_email_incoming_apply: "Áp dụng",
  cockpit_email_incoming_adjust: "Điều chỉnh việc gán",
  cockpit_email_incoming_saving: "Đang lưu …",
  cockpit_email_incoming_unassigned: "Chưa gán",
  cockpit_email_incoming_show_less: "Thu gọn",
  cockpit_email_incoming_show_all: "Hiện tất cả {{n}}",
  cockpit_io_settings: "Cài đặt Kjuup.io",
  cockpit_io_settings_sub: "Gói và số chỗ, phân công nhân viên, thanh toán và hóa đơn.",
  products_coming_soon: "Sắp ra mắt",
  cockpit_upsell_io_title: "Văn phòng biết nghĩ cùng bạn",
  cockpit_upsell_io_text: "Kết nối tài khoản email của bạn với Kjuup. Email, tệp đính kèm và tin nhắn được lưu tự động vào đúng dự án và có thể lưu tùy chọn trên máy chủ của bạn. Mỗi ngày bạn nhận bản tóm tắt tất cả dự án với các điểm chính từ mọi nội dung, và công việc của bạn đồng bộ với lịch hoặc ứng dụng việc cần làm.",
  cockpit_upsell_io_soon_title: "Chưa thể đặt mua",
  cockpit_upsell_io_soon_text: "Kjuup.io sắp ra mắt. Hãy yêu cầu thông tin ngay – chúng tôi sẽ báo cho bạn khi có thể đặt mua Kjuup.io.",
  cockpit_upsell_io_planned_price: "Giá dự kiến",
  cockpit_upsell_io_cta_request: "Yêu cầu thông tin",
  kjuup_plus_abo_per_year: "/ năm",
  kjuup_plus_abo_per_month: "/ tháng",
  kjuup_plus_abo_status_active: "Đang hoạt động",
  kjuup_plus_abo_status_requested: "Đã yêu cầu hủy",
  kjuup_plus_abo_status_past_due: "Đến hạn thanh toán",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Đăng ký",
  kjuup_plus_abo_title: "Gói Kjuup+",
  kjuup_plus_abo_seats_free_one: "Còn 1 chỗ",
  kjuup_plus_abo_billing: "Thanh toán",
  kjuup_plus_abo_yearly: "Hàng năm",
  kjuup_plus_abo_monthly: "Hàng tháng",
  kjuup_plus_abo_amount: "Số tiền",
  kjuup_plus_abo_ends: "Kết thúc vào",
  kjuup_plus_abo_renews: "Gia hạn tiếp theo",
  kjuup_plus_abo_next_invoice: "Hóa đơn tiếp theo",
  kjuup_plus_abo_intro: "Giá giới thiệu",
  kjuup_plus_abo_pending_tier: "Từ lần gia hạn tiếp theo",
  kjuup_plus_abo_manual: "Kjuup+ đang hoạt động cho công ty của bạn theo thỏa thuận riêng.",
  kjuup_plus_abo_invoices: "Hóa đơn",
  kjuup_plus_abo_invoice_paid: "Đã thanh toán",
  kjuup_plus_abo_invoice_view: "Xem",
  kjuup_plus_abo_invoices_less: "Thu gọn",
  kjuup_plus_abo_member_hint: "Quản trị viên công ty của bạn quản lý thanh toán và việc hủy.",
  kjuup_plus_abo_withdraw: "Rút lại yêu cầu",
  kjuup_plus_abo_cancel_note: "Lý do (không bắt buộc)",
  kjuup_plus_abo_cancel_send: "Yêu cầu hủy",
  kjuup_plus_abo_cancel: "Hủy đăng ký",
  cockpit_upsell_plus_f1: "Quản lý hoạt động giao tiếp của tất cả nhân viên",
  cockpit_upsell_plus_f2: "Thông báo cho các nhóm người dùng cụ thể trong công ty",
  cockpit_upsell_plus_f3: "Lưu các cuộc trò chuyện nhóm nội bộ",
  cockpit_upsell_plus_when_yearly: "khi thanh toán hàng năm",
  cockpit_upsell_plus_size_small: "1–50 nhân viên",
  cockpit_upsell_plus_size_large: "51–200 nhân viên",
  cockpit_upsell_plus_title: "Kjuup+ cho doanh nghiệp",
  cockpit_upsell_plus_text: "Quản lý nhân viên, quyền ghi và giao tiếp công ty ở một nơi. Kênh nội bộ dành riêng cho nhóm của bạn, kênh bên ngoài kết nối bạn với đối tác dự án và bạn có thể liên hệ trực tiếp các nhóm cụ thể. Ngoài Kjuup+, bạn có thể đặt thêm quyền truy cập Kjuup.io cho các nhóm nhân viên. Kjuup+ và Kjuup.io có thể kết hợp với nhau.",
  cockpit_upsell_plus_size: "Quy mô công ty",
  cockpit_upsell_plus_billing: "Thanh toán",
  cockpit_upsell_plus_per_company: "/ công ty · tháng, chưa gồm VAT",
  cockpit_upsell_plus_onboarding: "Chi phí triển khai/hướng dẫn tùy theo quy mô công ty",
  cockpit_upsell_plus_larger: "Giá cho công ty lớn hơn theo yêu cầu",
  cockpit_upsell_plus_cta: "Hỏi thông tin không ràng buộc",
  cockpit_kpi_deadlines_tasks: "Thời hạn & công việc",
  cockpit_kpi_appointments: "Lịch hẹn",
  cockpit_room_admin: "Quản lý dự án & trò chuyện",
  cockpit_room_admin_sub: "Tất cả dự án của công ty cùng thành viên, phương tiện và cuộc trò chuyện.",
  pro_todo_not_found: "Công việc này không còn khả dụng.",
  cockpit_chip_overdue: "Quá hạn",
  cockpit_chip_today: "Hôm nay",
  cockpit_calendar_week: "Tuần {{week}}",
  cockpit_prev_week: "Tuần trước",
  cockpit_next_week: "Tuần sau",
  cockpit_chip_requested: "Đã yêu cầu",
  cockpit_todo_due: "Hạn {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "từ {{name}}",
  cockpit_todo_since: "từ {{when}}",
  cockpit_todo_no_date: "Chưa có ngày",
  cockpit_todo_mark_done: "Đánh dấu hoàn thành",
  cockpit_my_tasks_title: "Công việc của tôi",
  cockpit_today_tasks_group: "Công việc hôm nay",
  cockpit_assign_none: "Chưa gán cho ai",
  no_project_found: "Không tìm thấy dự án",
  cockpit_row_more_actions: "Thao tác khác",
  needs_date: "Gán ngày",
  cockpit_assign_proposal: "Đã nhận ra {{name}} – gán?",
  cockpit_assign_proposal_confirm: "Gán",
  cockpit_assign_proposal_dismiss: "Bỏ qua",
  cockpit_priority_date: "Ngày",
  todo_calendar_add: "Thêm vào lịch",
  todo_calendar_remove: "Xóa khỏi lịch",
  cockpit_todo_change_project: "Đổi dự án",
  cockpit_todo_set_date: "Đặt ngày",
  pro_todo_done_confirm: "Bạn có thực sự muốn đánh dấu công việc này là hoàn thành không?",
  cockpit_task_delete_failed: "Không thể xóa công việc.",
  cockpit_setup_title: "Hoàn tất thiết lập",
  cockpit_setup_text: "Hãy quyết định có dùng trò chuyện hay không, và Kjuup.io sẽ hoạt động như ứng dụng email hay chỉ với dự án và báo cáo hàng ngày.",
  cockpit_setup_cta: "Thiết lập ngay",
  cockpit_group_tasks: "Thời hạn & công việc",
  cockpit_group_appointments: "Lịch hẹn",
  cockpit_report_no_activity: "Dự án này không có tin nhắn hoặc email mới trong 24 giờ qua.",
  cockpit_report_room_unavailable: "Dự án này không khả dụng.",
  cockpit_report_create_failed: "Không thể tạo báo cáo hàng ngày.",
  cockpit_report_created: "Đã tạo báo cáo hàng ngày",
  addon_enable_confirm: "Bật tiện ích bổ sung?",
  addon_enable: "Bật",
  addon_enabled: "Đã bật tiện ích bổ sung",
  nav_email: "Email",
  nav_my_cockpit: "Bảng điều khiển của tôi",
  nav_news: "Tin tức",
  nav_recommend: "Giới thiệu",
  pro_todo_status_done: "Hoàn thành",
  pro_todo_status_open: "Đang mở",
  v2_todo_remove: "Xóa",
  pro_todo_search_people: "Tìm người",
  pro_todo_clear: "Xóa",
  pro_todo_assigned: "(đã gán)",
  pro_todo_no_people: "Không tìm thấy người nào",
  pro_todo_search_rooms: "Tìm dự án",
  pro_todo_no_rooms_match: "Không có dự án nào khớp với “{{q}}”",
  pro_todo_no_rooms: "Không tìm thấy dự án",
  pro_todo_activity: "Hoạt động",
  pro_todo_show_less: "Thu gọn",
  pro_todo_show_all: "Hiện tất cả ({{n}})",
  pro_todo_due: "Hạn",
  pro_todo_room: "Dự án",
  pro_todo_select_room: "Chọn dự án",
  pro_todo_status: "Trạng thái",
  pro_todo_more: "Thêm",
  pro_todo_edit_title: "Sửa công việc",
  pro_todo_description: "Mô tả",
  pro_todo_created_by: "Người tạo",
  pro_todo_chat: "Trò chuyện",
  navigate_to_source: "Đi đến nguồn",
  todo_calendar_connect_title: "Chưa kết nối lịch",
  todo_calendar_connect_body_web: "Hãy kết nối lịch trong cài đặt Đồng bộ lịch để thêm việc cần làm vào đó.",
  todo_calendar_connect: "Kết nối",
  todo_calendar_removed: "Đã xóa khỏi lịch của bạn",
  todo_calendar_added_later: "Đã thêm. Không thể truy cập lịch của bạn; Kjuup sẽ thử lại sau.",
  todo_calendar_added: "Đã thêm vào lịch của bạn",
  todo_calendar_no_date: "Chỉ việc cần làm có ngày mới có thể thêm vào lịch.",
  todo_calendar_failed: "Không thể cập nhật lịch của bạn. Vui lòng thử lại.",
  todo_calendar_date_title: "Chưa có ngày",
  todo_calendar_date_save: "Đặt ngày & thêm",
  todo_calendar_date_body_web: "Công việc đã đánh dấu này chưa có ngày. Hãy đặt ngày để thêm vào lịch.",
  kjuup_io_setup_saved: "Đã lưu thiết lập",
  kjuup_io_setup_step: "Bước",
  kjuup_io_setup_chats_title: "Bạn có muốn dùng trò chuyện không?",
  kjuup_io_setup_email_title: "Bạn muốn đọc email ở đâu?",
  kjuup_io_setup_chats_sub: "Trò chuyện với đồng nghiệp và đối tác dự án là tùy chọn. Bạn có thể hiện hoặc ẩn chúng trên bảng điều khiển bất cứ lúc nào.",
  kjuup_io_setup_email_sub: "Thao tác này chỉ chọn việc bạn dùng ứng dụng email trong Kjuup hay tiếp tục dùng chương trình email hiện tại, chẳng hạn Outlook hoặc chương trình khác. Bạn có thể đổi sau.",
  kjuup_io_setup_chats_yes: "Có, hiện trò chuyện",
  kjuup_io_setup_chats_yes_text: "Tin nhắn gồm trò chuyện và email. Dự án có nhóm trò chuyện cho mọi người tham gia.",
  kjuup_io_setup_chats_no: "Không, làm việc không cần trò chuyện",
  kjuup_io_setup_chats_no_text: "Trò chuyện bị ẩn. “Tin nhắn” trở thành “Email”; dự án, công việc và báo cáo hàng ngày vẫn giữ nguyên.",
  kjuup_io_setup_email_client: "Ứng dụng email trong Kjuup",
  kjuup_io_setup_email_client_text: "Đọc và trả lời email trực tiếp trong Kjuup.",
  kjuup_io_setup_email_reports: "Ứng dụng email hiện tại",
  kjuup_io_setup_email_reports_text: "Tiếp tục đọc và trả lời trong chương trình hiện tại của bạn, chẳng hạn Outlook hoặc chương trình khác.",
  kjuup_io_setup_skip: "Để sau",
  next: "Tiếp",
  kjuup_io_setup_finish: "Hoàn tất thiết lập",
  today_label: "hôm nay",
  tomorrow_label: "ngày mai",
  cockpit_todo_overdue: "quá hạn",
  cockpit_report_management_fazit: "Tóm tắt quản lý",
  cockpit_todo_appointment: "Lịch hẹn",
  cockpit_todo_deadline: "Thời hạn",
  cockpit_todo_deadline_define: "Đặt thời hạn",
  pro_todo_status_acknowledged: "Đã xác nhận",
  pro_todo_responsible: "Người phụ trách",
  pro_todo_notice_confirmed: "Đã xác nhận trong trò chuyện",
  pro_todo_notice_sent_at: "Đã gửi tin nhắn",
  pro_todo_notice_again: "Gửi lại tin nhắn",
  pro_todo_notice_send: "Thông báo qua tin nhắn Kjuup",
  pro_todo_add_assignee: "Thêm",
  pro_todo_edit: "Sửa",
  pro_todo_change_room: "Đổi dự án",
  pro_todo_due_on: "Hạn vào",
  pro_todo_edit_due: "Sửa ngày hạn",
  pro_todo_no_date: "Chưa có ngày",
  pro_todo_edit_description: "Sửa mô tả",
  pro_todo_no_description: "Chưa có mô tả",
  pro_todo_title_label: "Tiêu đề",
  pro_todo_title_placeholder: "Nhập tiêu đề...",
  pro_todo_task: "Nhiệm vụ",
  pro_todo_what: "Cần làm gì?",
  pro_todo_source_email: "Email",
  pro_todo_sources: "Nguồn",
  previous: "Trước",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (tối đa {max} nhân viên)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (tối đa {max} nhân viên)",
  kjuup_plus_abo_status_ends: "Kết thúc vào {date}",
  kjuup_plus_abo_seats_over: "Hơn {max} nhân viên – Kjuup sẽ liên hệ với bạn để gửi báo giá riêng.",
  kjuup_plus_abo_seats_next: "Nếu có thêm nhân viên, gói sẽ tự động chuyển sang {next} (tính phí theo tỷ lệ).",
  kjuup_plus_abo_seats_used: "Đã dùng {used}/{total} chỗ",
  kjuup_plus_abo_seats_free: "Còn {count} chỗ",
  kjuup_plus_abo_intro_until: "đến {date}",
  kjuup_plus_abo_invoice_open: "Chưa thanh toán · đến hạn {date}",
  kjuup_plus_abo_invoices_all: "Hiển thị tất cả {count}",
  kjuup_plus_abo_requested_hint: "Đã yêu cầu hủy vào {date}. Kjuup sẽ xác nhận vào cuối kỳ hạn ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup sẽ xem xét yêu cầu của bạn và xác nhận việc hủy vào cuối kỳ hạn ({end}). Kjuup+ vẫn hoạt động đến lúc đó.",
  kjuup_plus_abo_withdrawn: "Đã rút lại yêu cầu hủy",
  kjuup_plus_abo_requested: "Đã yêu cầu hủy",
  cockpit_upsell_plus_intro_hint: "{months} tháng đầu, sau đó {price}",
  cockpit_upsell_plus_badge: "GIÁ ƯU ĐÃI {months} THÁNG ĐẦU",
  calendar_syncing: "Đang cập nhật từ lịch…",
  calendar_sync_up_to_date: "Lịch đã là mới nhất",
  calendar_sync_failed: "Đồng bộ thất bại",
  delete_multiple_tasks_confirm: "Bạn có chắc muốn xóa {count} ToDo?",
  todos_deleted_count: "Đã xóa {count} ToDo",
  todos_deleted_partial: "Đã xóa {ok} ToDo, {fail} thất bại",
  todo_unknown: "Không rõ",
  todo_created_from_message: "Đã tạo công việc từ tin nhắn này",
  kjuup_io_todo_calendar_trial_ended_note: "Đồng bộ lịch · Đăng ký",
  kjuup_io_todo_calendar_nudge: "Đồng bộ ToDo này vào lịch của bạn?",
  kjuup_io_todo_calendar_nudge_cta: "Kích hoạt Kjuup.io",
  todo_confirmed: "ToDo đã xác nhận",
  pro_todo_bulk_delete_title: "Xóa {{n}} công việc?",
  pro_todo_previous_none_own: "Các công việc quá hạn do người khác giao cho bạn và chỉ họ mới có thể xóa.",
  pro_todo_previous_none: "Không có công việc quá hạn",
  pro_todo_previous_title: "Xóa {{n}} công việc quá hạn?",
  pro_todo_previous_text: "Tất cả công việc đang mở của bạn từ những ngày trước sẽ bị xóa.",
  pro_todo_previous_skipped: "{{n}} công việc do người khác giao sẽ được giữ lại.",
  unassign_task_confirm: "Bạn có muốn hủy giao mình khỏi công việc này?",
  unassign_label: "Hủy giao",
  pro_todo_delete_title: "Xóa công việc",
  pro_todo_today: "Hôm nay",
  pro_todo_yesterday: "Hôm qua",
  pro_todo_since_yesterday: "Từ hôm qua",
  pro_todo_mark_open: "Đánh dấu là đang mở",
  verify_completion: "Xác nhận",
  new_label: "Mới",
  bookmarked_no_mylist: "Không thể thêm nhiệm vụ đã đánh dấu vào Danh sách của tôi",
  delete_only_own: "Bạn chỉ có thể xóa công việc do chính bạn tạo",
  todo_clear_all: "Xóa tất cả",
  pro_todo_of_completed: "Đã hoàn thành {{done}}/{{total}}",
  pro_todo_pick_date: "Chọn một ngày",
  pro_todo_show_day: "Hiện ngày",
  todo_adjust_list: "Điều chỉnh danh sách",
  pro_todo_section_upcoming: "Sắp tới",
  pro_todo_section_done: "Hoàn thành",
  pro_todo_room_empty_today: "Hôm nay không có công việc nào trong dự án này",
  pro_todo_room_empty_day: "Không có công việc nào vào ngày này trong dự án này",
  pro_todo_delete_previous: "Xóa tất cả",
  todo_my_list_empty: "Ngày của bạn trống",
  todo_my_list_empty_hint: "Nhấp vào “Điều chỉnh danh sách” để thêm công việc",
  pro_todo_empty_title: "Không có gì ở đây",
  pro_todo_empty_hint: "Không có nhiệm vụ nào khớp với chế độ xem này.",
  pro_todo_selected: "Đã chọn {{n}}",
  delete_selected_count: "Xóa ({count})",
  pro_todo_adjust_done: "Xong",
  pro_todo_deleting: "Đang xóa...",
  pro_todo_reopen: "Mở lại nhiệm vụ",
  pro_todo_step_done: "Hoàn thành",
  move_back_in_progress: "Quay lại đang thực hiện",
  pro_todo_mark_not_started: "Đánh dấu chưa bắt đầu",
  back_into_in_progress: "Quay lại đang thực hiện",
  pro_todo_mark_in_progress: "Đánh dấu đang thực hiện",
  unassign_todo: "Hủy giao ToDo",
  pro_todo_open_room: "Mở dự án",
  pro_todo_new_task: "Nhiệm vụ mới",
  select_user_back_to_in_progress: "Chọn người dùng để chuyển lại sang đang thực hiện",
  cockpit_email_accounts_n_many: "Đã kết nối {{n}} tài khoản",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Danh bạ Kjuup",
  combined_tab_teams: "Danh bạ Teams",
  combined_bridge_failed: "Không thể tạo bản sao Teams.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Danh bạ Kjuup và Teams: một nhóm mới được tạo và cũng hiển thị trong Microsoft Teams.",
  teams_new_chat_title: "Cuộc trò chuyện Teams mới",
  teams_new_chat_topic: "Tên nhóm (không bắt buộc)",
  teams_new_chat_start: "Bắt đầu trò chuyện",
  teams_new_chat_creating: "Đang tạo cuộc trò chuyện…",
  teams_new_chat_forbidden: "Microsoft Teams không cho phép cuộc trò chuyện này (ví dụ: người ngoài tổ chức của bạn hoặc chính sách của bộ phận IT).",
  teams_new_chat_too_many: "Quá nhiều người cho một cuộc trò chuyện.",
  teams_new_chat_type_hint: "Nhập tên để tìm trong tổ chức của bạn.",
  teams_new_chat_directory_forbidden: "Tổ chức của bạn không cho phép tìm trong danh bạ. Chỉ hiển thị những người từ các cuộc trò chuyện Teams của bạn.",
  teams_new_chat_account: "Tài khoản",
};
